import { useMediaQuery } from '@material-ui/core'
import moment from 'moment'
import { useRouter } from 'next/router'
// import moment from 'moment'
import * as React from 'react'
import { animated, useSpring } from 'react-spring'
import styled from 'styled-components'
import ProfileImage from '../../profile/image'
import SkeletonItem from '../details/ActivityDetails/SkeletonItem'
import { EnrichedTokenAccount } from '../details/LeaderboardDetails'

const OuterDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  overflow: visible;
`

const InnerDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const EventDiv = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 43em) {
    margin-left: 15px;
  }
`

const Title = styled(animated.div)<{ neutral: boolean }>`
  color: ${(props) => (props.neutral ? 'white' : 'rgb(48, 209, 88)')};
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;

  @media (min-width: 43em) {
    font-size: 17px;
  }
`

const Subtitle = styled.div`
  color: white;
  font-size: 14px;
  font-weight: 500;

  @media (min-width: 43em) {
    font-size: 17px;
  }
`

const StartDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const Divider = styled.div`
  width: 100%;
  background: #323232;
  height: 1px;
  margin-top: 15px;
`

const Place = styled.div`
  color: white;
  font-size: 24px;
  font-weight: 500;
  margin-right: 20px;
  @media (min-width: 43em) {
    font-size: 36px;
  }
`

interface LeaderboardItemProps {
  tokenAccount?: EnrichedTokenAccount
  index?: number
}

const LeaderboardItem = ({ tokenAccount, index }: LeaderboardItemProps): JSX.Element => {
  const { owner, amount } = tokenAccount || {}
  const createdAt = tokenAccount?.createdAt ? new Date(tokenAccount.createdAt) : new Date()
  const isMobile = useMediaQuery('(max-width: 43em)')
  const [profileHover, setProfileHover] = React.useState(false)
  const router = useRouter()

  const profileHoverState = useSpring({
    cursor: 'pointer',
    borderRadius: isMobile ? 40 : 50,
    transform: profileHover ? `translate3d(0,-5%,0)` : `translate3d(0,0%,0)`,
    config: {
      mass: 1,
      tension: 170,
      friction: 26,
      velocity: 0,
    },
  })

  const textHoverState = useSpring({
    cursor: 'pointer',
    textDecoration: profileHover ? 'underline' : 'none',
    config: {
      mass: 1,
      tension: 170,
      friction: 26,
      velocity: 0,
    },
  })

  const openProfile = (address: string): void => {
    router.push(`/${address}`)
  }

  if (!tokenAccount || !owner) {
    return <SkeletonItem />
  }

  return (
    <OuterDiv>
      <InnerDiv>
        <StartDiv>
          {!isMobile && (
            <animated.div
              onMouseEnter={() => setProfileHover(true)}
              onMouseLeave={() => setProfileHover(false)}
              style={profileHoverState}
              onClick={() => openProfile(owner.address)}
            >
              <ProfileImage item={owner} size={isMobile ? 40 : 50} />
            </animated.div>
          )}
          <EventDiv>
            <Title
              neutral={true}
              onMouseEnter={() => setProfileHover(true)}
              onMouseLeave={() => setProfileHover(false)}
              style={textHoverState}
              onClick={() => openProfile(owner.address)}
            >
              {owner.displayName}
            </Title>
            <Subtitle>
              {`${amount} edition${amount > 1 ? 's' : ''}` +
                ' · ' +
                `Supporter for ${moment(createdAt).fromNow(true)}`}
            </Subtitle>
          </EventDiv>
        </StartDiv>
        <Place>{index === 1 ? '🥇' : index === 2 ? '🥈' : index === 3 ? '🥉' : index}</Place>
      </InnerDiv>

      <Divider />
    </OuterDiv>
  )
}

export default LeaderboardItem
